import { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  Collapse,
  FormControl,
  Grid2,
  MenuItem,
  Pagination,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,

} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useAuth from 'hooks/useAuth';
import MainCard from 'components/MainCard';
import { ArrowDown2, ArrowUp2, Calendar1} from 'iconsax-react';
import IconButton from 'components/@extended/IconButton';

import { dispatch } from 'store';
import {
  resetStatecoursereport,
} from 'store/reducers/coursereport';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Snackbar from 'utils/Snackbar';
import Loader2 from 'components/Loader2';
import { FormattedMessage } from 'react-intl';

import { formatDateBasedOnOrgSettings} from 'utils/helper';
;
import React from 'react';
import { getWeeklyReport } from 'services/report.service';

const WeeklyReport = () => {
  const theme = useTheme();
  const {organization } = useAuth();
  const [weeklyData, setWeeklyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openRow, setOpenRow] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleChange = (event: SelectChangeEvent<number>) => {
    setPageSize(+event.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (event: any, page: number) => {
    setCurrentPage(page);
  };
  const handleRowClick = (id: string) => {

    setOpenRow(openRow === id ? null : id);
  };
  useEffect(() => {
    fetchWeeklyReport();
  }, [currentPage, pageSize]);
  useEffect(() => {
    return () => {
      dispatch(resetStatecoursereport());
    };
  }, [dispatch]);


  const fetchWeeklyReport = async () => {
    setIsLoading(true);
  
    try {
      let reqData = {
        skip: currentPage,
        limit: pageSize
      };
      getWeeklyReport(reqData)
        .then((result:any) => {
          setIsLoading(false);
        
          setCount(result?.data?.data?.count);
          setWeeklyData(result?.data?.data?.data);
        
        })
        .catch((err:any) => {
          setIsLoading(false);
          if (err?.response?.status === 403) {
            const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
            Snackbar(errorMessage, 'warning');
          } else {
            const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
            Snackbar(errorMessage, 'error');
          }
        });
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  return (
    <>
      {/* <MainCard title={<FormattedMessage id="Course Report" />}>
        <Grid2 container spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
          {cardData.map((data, index) => (
            <Grid2 item xs={data.screen.xs} sm={data.screen.sm} md={data.screen.md} lg={data.screen.lg} key={index}>
              <CardTotalCount primary={data.value} secondary={data.name} />
            </Grid2>
          ))}
        </Grid2>
      </MainCard>
      <br /> */}
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} gap={'5px'}>
            <MainCard
              title={
                <Typography variant="h5">
                
             
              <FormattedMessage id="Weekly Report List"/>
              </Typography>
              }
              content={false}
              sx={{
                '& .MuiCardHeader-root': {
                  padding: '7px 13px'
                }
              }}
            ></MainCard>
            <MainCard content={false}>
              <DndProvider backend={HTML5Backend}>
                {isLoading ? (
                  <Loader2 />
                ) : (
                  <Box>
                    <TableContainer component={Paper} sx={{ maxHeight: 370 }}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="Class" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="class teacher" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="Total Students" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="ongoing courses Count" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="Weekly progress change Count" />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage id="View Students" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {weeklyData && weeklyData.length > 0 ? (
                            weeklyData.map((batch: any) => {
                              const courseCount = batch?.users?.reduce((total: number, user: any) => {
                                return total + (user?.courses?.length || 0);
                              }, 0);
                              const progressCount = batch?.users?.reduce((total: number, user: any) => {
                                return total + (user?.courses ? user.courses.filter((course: any) => course.progressMade).length : 0);
                              }, 0);
                              const allCourses = batch.users.flatMap(
                                (student: any) =>
                                  student?.courses?.map((course: string) => ({
                                    course,
                                    firstName: student?.firstName,
                                    lastName: student?.lastName
                                  })) || []
                              );

                              return (
                                <React.Fragment key={batch._id}>
                                  <TableRow>
                                    <TableCell>{batch?.classroom?.className}</TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>
                                      {batch?.classroom?.classTeacher ? (
                                        <Typography>
                                          {`${batch?.classroom?.classTeacher?.firstName || ''} ${
                                            batch?.classroom?.classTeacher?.lastName || ''
                                          }`}
                                        </Typography>
                                      ) : (
                                        '--'
                                      )}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>{batch?.users?.length || '0'}</TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>{courseCount || '0'}</TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>{progressCount || '0'}</TableCell>

                                    {/* <TableCell sx={{ padding: '3px !important' }}>{getTotalSubscribedCount(batch._id)}</TableCell> */}
                                    <TableCell sx={{ padding: '3px !important' }}>
                                      <IconButton size="small" onClick={() => handleRowClick(batch._id)}>
                                        {openRow === batch._id ? <ArrowUp2 /> : <ArrowDown2 />}
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell sx={{ padding: 0, border: 'none' }} colSpan={6}>
                                      <Collapse in={openRow === batch._id} timeout="auto" unmountOnExit>
                                        <Box>
                                          <Table size="small">
                                            <TableHead>
                                              <TableRow>
                                                <TableCell>
                                                  <FormattedMessage id="Name" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Course" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Progress" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Status" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Enrolled At" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Last Updated At" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Progress made this week?" />
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <>
                                              {allCourses.map((student: any) => {
                                                return (
                                                  <TableRow key={student.id}>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {' '}
                                                      {student ? (
                                                        <Typography>{`${student?.firstName || ''} ${student?.lastName || ''}`}</Typography>
                                                      ) : (
                                                        '--'
                                                      )}
                                                    </TableCell>

                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {student?.course?.courseId?.name || '--'}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important', textAlign: 'center' }}>
                                                      {student?.course?.progress || '0'}%
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      <>
                                                        {student?.course?.status === 'not started' ? (
                                                          <Chip
                                                            color="error"
                                                            variant="filled"
                                                            label={<strong> {student?.course?.status || '0'}</strong>}
                                                            size="small"
                                                          />
                                                        ) : student?.course?.status === 'in progress' ? (
                                                          <Chip
                                                            color="warning"
                                                            variant="filled"
                                                            label={<strong> {student?.course?.status || '0'}</strong>}
                                                            size="small"
                                                          />
                                                        ) : (
                                                          <Chip
                                                            color="success"
                                                            variant="filled"
                                                            label={<strong> {student?.course?.status || '0'}</strong>}
                                                            size="small"
                                                          />
                                                        )}
                                                      </>
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {formatDateBasedOnOrgSettings(student?.course?.enrollmentDate, organization) || '--'}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {formatDateBasedOnOrgSettings(student?.course?.updated_at, organization) || '--'}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important', textAlign: 'center' }}>
                                                      {student?.course?.progressMade ? '✔' : '❌'}
                                                    </TableCell>

                                                    <TableCell sx={{ padding: '0px !important' }}>
                                                   
                                                    </TableCell>
                                                  </TableRow>
                                                );
                                              })}
                                            </>
                                          </Table>
                                        </Box>
                                      </Collapse>
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <Grid2
                              container
                              direction="row"
                              justifyContent="center"
                              textAlign="center"
                              alignItems="center"
                              sx={{
                                height: '100%',
                                paddingTop: '50px',
                                paddingBottom: '50px',
                                marginLeft: { lg: '300px', md: '200px', sm: '100px', xs: '50px' }
                              }}
                            >
                              <Grid2 size={12}>
                                <Calendar1 size="200" color={theme.palette.primary.main} variant="Bold" />
                              </Grid2>
                              <Grid2 size={12} margin={1}>
                                <Typography sx={{ fontWeight: 'bold' }}>{'No Week Reports Yet'}</Typography>
                              </Grid2>
                            </Grid2>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
              </DndProvider>

              <Box sx={{ p: 1 }}>
                <Grid2 container alignItems="center" justifyContent="space-between" sx={{ width: 'auto' }}>
                  <Grid2>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="caption" color="secondary">
                          <FormattedMessage id="Row per page" />
                        </Typography>
                        <FormControl sx={{ m: 1 }}>
                          <Select
                            id="demo-controlled-open-select"
                            open={open}
                            onClose={handleClose}
                            onOpen={handleOpen}
                            value={pageSize}
                            onChange={handleChange}
                            size="small"
                            sx={{ '& .MuiSelect-select': { py: 0.75, px: 1.25 } }}
                          >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                        </FormControl>
                      </Stack>
                    </Stack>
                  </Grid2>
                  <Grid2 sx={{ mt: { xs: 2, sm: 0 } }}>
                    <Pagination
                      onChange={handlePageChange}
                      count={Math.ceil(count / pageSize)}
                      page={currentPage}
                      variant="combined"
                      color="primary"
                    />
                  </Grid2>
                </Grid2>
              </Box>
            </MainCard>
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
};

export default WeeklyReport;
